import React from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import { PlagiarismAnalysisModel } from "./PlagiarismReportViewModels";

export function PlagiarismAnalysisTable(props: {
	className: string;
	courseId: number;
	plagiarismData?: PlagiarismAnalysisModel[];
}) {
	const studentNameTemplate = (rowData: PlagiarismAnalysisModel) => {
		return (
			<Link
				className="link"
				to={`/scoreReport?draftId=${rowData.draftId}`}
				state={{ section: "PlagiarismAnalysis" }}>
				{rowData.writerName}
			</Link>
		);
	};

	const percentPlagiarismTemplate = (rowData: PlagiarismAnalysisModel) => {
		const score = Math.round(rowData.plagiarismScore * 100);
		const percent = score == 0 ? "No" : `${score}%`;
		return `${percent} plagiarism  detected`;
	};

	const flaggedSentencesTemplate = (rowData: PlagiarismAnalysisModel) => {
		const count = rowData.plagiarismSentences === 0 ? "No" : rowData.plagiarismSentences;
		const sentence = rowData.plagiarismSentences === 1 ? "sentence" : "sentences";
		const was = rowData.plagiarismSentences === 1 ? "was" : "were";
		return `${count} ${sentence} ${was} flagged for plagiarism`;
	};

	return (
		<DataTable
			value={props.plagiarismData}
			dataKey="draftId"
			loading={props.plagiarismData == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}>
			<Column
				header="Student"
				body={studentNameTemplate}
				sortable
				sortField="writerName"></Column>
			<Column
				header="Percentage of Plagiarism Detected"
				body={percentPlagiarismTemplate}
				sortField="plagiarismScore"
				sortable></Column>
			<Column
				header="# of Sentences with Plagiarism"
				body={flaggedSentencesTemplate}
				sortField="plagiarismSentences"
				sortable></Column>
		</DataTable>
	);
}
